<section class="footer-container" [ngClass]="backgroundColor">
  <footer class="test wrapper pattern-wrapper bg-image section-frame" >
      <div class="container pb-13 pb-md-15">
          <div class="card image-wrapper bg-full bg-image bg-overlay mt-n50p mx-md-5 rounded-xl overflow-hidden card-container">
              <img dynamicImage [baseImageSrc]="footerData?.banner?.img" [displayResolutions]="[IMAGES_RESOLUTIONS.sm]" class="img-bg-fill" alt="bannerImage">
          <div class="card-body card-data p-6 p-md-11 d-lg-flex flex-row align-items-lg-center justify-content-md-between text-center text-lg-start">
            <h3 class="display-2 mb-6 mb-lg-0 pe-lg-10 pe-xl-5 pe-xxl-18 text-white">{{footerData?.banner?.title}}</h3>
            <button class="btn btn-lg btn-white rounded-xl mb-0 text-nowrap" (click)="goToLink(landingPageBanner.showHeaderSections.contact_us_link)">
              {{footerData?.banner?.button}}
            </button>
          </div>
        </div>

        <div class="text-inverse mx-md-5 mt-n15 mt-lg-0">
          <div class="row gy-6 gy-lg-0 content-container">
            <div class="col-lg-4">
              <div class="widget">
                <h3 class="h2 mb-3 text-white" [innerHTML]="footerData?.footer?.title"></h3>
                <p class="mb-5" [innerHTML]="footerData?.footer?.description"></p>
                <div class="row ml">
                  <nav class="nav social media" *ngIf="footerData?.socialMedia.length">
                      <div class="row" *ngFor="let socialMedia of footerData?.socialMedia; let i = index">
                        <a class="iconSocialMedia" href="https://{{socialMedia.link}}" target="_blank" [attr.aria-label]="socialMedia.name" >
                          <div class="icon-container">
                              <mat-icon  color="primary" [svgIcon]="'app_'+ socialMedia.name.toLocaleLowerCase()"></mat-icon>
                          </div>
                        </a>
                      </div>
                  </nav>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-lg-2">
              <div class="widget">
                <h4 class="widget-title text-white mb-3" *ngIf="landingPageBanner?.showHeaderSections?.projects ||
                landingPageBanner?.showHeaderSections?.blog ||
                landingPageBanner?.showHeaderSections?.careers ||
                landingPageBanner?.showHeaderSections?.contactUs ||
                landingPageBanner?.showHeaderSections?.aboutUs">{{'landing.navigation' | translateWithKeys}}</h4>
                <ul class="list-unstyled mb-0">
                  <li *ngIf="landingPageBanner?.showHeaderSections?.projects" class="li-res"><a [routerLink]="['/projects/listing']">{{ landingPageBanner?.showHeaderSections?.projects_text === '' ? ("landing.projects" | translateWithKeys) : landingPageBanner?.showHeaderSections?.projects_text }}</a></li>
                  <li *ngIf="landingPageBanner?.showHeaderSections?.blog"><a [routerLink]="['/blog']">{{ landingPageBanner?.showHeaderSections?.blog_text === '' ? ("landing.blogs" | translateWithKeys) : landingPageBanner?.showHeaderSections.blog_text }}</a></li>
                  <li *ngIf="landingPageBanner?.showHeaderSections?.careers"><a [routerLink]="['/jobs']">{{ landingPageBanner?.showHeaderSections?.careers_text === '' ? ("landing.careers" | translateWithKeys) : landingPageBanner?.showHeaderSections?.careers_text }}</a></li>
                  <li *ngIf="footerData?.pricing?.show"><a routerLink="#">Pricing</a></li>
                </ul>
              </div>
            </div>

            <div class="col-md-6 col-lg-3">
              <div class="widget">
                <h4 class="widget-title text-white mb-3">{{'landing.get_in_touch' | translateWithKeys}}</h4>
                <address>{{footerData?.company.address}}</address>
                <a href="mailto:{{footerData?.company?.email}}">{{footerData?.company?.email}}</a>
                <br>
                <a href="tel:{{footerData?.company?.phone}}">{{footerData?.company?.phone}}</a>
              </div>
            </div>
          </div>

        </div>
      </div>
  </footer>

</section>
